import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PreProcessSettings, AlertItem, AlertType, LotGeneration } from 'src/app/core/models';
import { AlertService, LotGenerationService } from 'src/app/core/services';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-pre-process-config-lot-manual',
  templateUrl: './config-lot-manual.component.html',
  styleUrls: ['./config-lot-manual.component.sass']
})
export class ConfigLotManualComponent implements OnInit {
  @Input() preProcessSettings: PreProcessSettings;
  @Output() nextStepCommand = new EventEmitter();
  @Output() outputValue = new EventEmitter();
  @Output() isValid = new EventEmitter();
  public formGroup: FormGroup;
  public promise: Promise<any>;
  public contractId: string;

  public lotGeneration: LotGeneration;

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private lotGenerationService: LotGenerationService
  ) { }

  ngOnInit() {
    this.contractId = this.activatedRoute.snapshot.params.contractId;
    this.createForm();
    this.loadLotGeneration().then(() => {
      this.createForm(this.lotGeneration || {} as any);
    });
  }

  private loadLotGeneration(): Promise<void> {
    return this.lotGenerationService.resolveLotGeneration(this.preProcessSettings.lotGenerationId as any).then(lotGeneration => {
      this.lotGeneration = lotGeneration;
    });
  }

  createForm(lotGeneration: any = {}) {
    if (this.formGroup == null) {
      this.formGroup = new FormGroup({});
    }
    this.formGroup = this.formBuilder.group({
      name: [lotGeneration.namePattern, Validators.required],
      path: [lotGeneration.pathPattern, Validators.required]
    });
    this.emitIsValid();
    this.formGroup.valueChanges.subscribe(() => {
      this.emitIsValid();
    });
  }

  private emitIsValid() {
    this.isValid.emit(this.formGroup.valid && this.formGroup.pristine);
  }

  confirm() {
    if (!this.formGroup.valid || this.promise != null) {
      return;
    }
    if (this.preProcessSettings.id == null) {
      this.alertService.show(new AlertItem('LotGenerationRequiresPreProcessSettings', AlertType.danger));
      return;
    }
    const payload = {
      preProcessSettingsId: this.preProcessSettings.id as any,
      contractId: Number(this.contractId),
      lotGeneration: {
        stopAttribution: this.lotGeneration?.stopAttribution,
        namePattern: this.formGroup.get('name').value,
        pathPattern: this.formGroup.get('path').value,
        autoGeneration: this.lotGeneration?.autoGeneration || []
      },
      lotSteps: this.preProcessSettings.lotSteps,
      violationSteps: this.preProcessSettings.violationSteps
    };
    this.promise = this.lotGenerationService.createOrUpdate(this.preProcessSettings.lotGenerationId, payload)
      .then(result => {
        this.preProcessSettings.lotGenerationId = Number(result.id);
        this.lotGeneration = result;
        this.formGroup.markAsPristine();
        this.emitIsValid();
        this.alertService.show(new AlertItem('LotGenerationSaved', AlertType.success));
      }).catch(err => {
        console.error(err);
        this.alertService.show(new AlertItem('LotGenerationSaveError', AlertType.danger));
      }).finally(() => {
        this.promise = null;
      });
  }

  cancel() {
    if (this.promise != null) {
      return;
    }
    this.loadLotGeneration().then(() => {
      this.createForm(this.lotGeneration || {} as any);
    });
  }
}
